import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { UpdateBatchInfo } from "../../services/BatchService";
import { NotificationManager } from "react-notifications";
import { GetUsers } from "../../services/usersService";

const locations = [
  "Madison 1",
  "Madison 2",
  "Madison 3",
];

const EditMicroOutBatchDialog = ({ open, onClose, batch, onSave }) => {
  const [inUser, setInUser] = useState("");
  const [inTime, setInTime] = useState("");
  const [location, setLocation] = useState("");
  const [pinUser, setpInUser] = useState("");
  const [batchEditHistory, setBatchEditHistory] = useState("");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (batch) {
      setInUser(batch.inUser || "");
      setInTime(batch.inTime || "");
      setLocation(batch.location || "");
      setpInUser(batch.inUser || "");
      setBatchEditHistory(batch.batchEditHistory || "");
    }
  }, [batch]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await GetUsers("ANALYSTS");
        setUsers(users);
      } catch (error) {
        NotificationManager.error("Failed to get Users:", error.message);
      }
    };
    fetchUsers();
  }, []);

  const handleSaveClick = async () => {
    let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser")).operator;
    const changes = [];

    const formatDate = (date) => {
      const d = new Date(date);
      return `${d.toLocaleDateString()} at ${d.toLocaleTimeString()}`;
    };

    const addHistory = (field, oldValue, newValue) => {
      if (oldValue !== newValue) {
        const timestamp = new Date().toLocaleString();
        changes.push(
          `${field} changed from "${oldValue}" to "${newValue}" by ${loggedInUser} on ${timestamp}`
        );
      }
    };

    addHistory("In User", pinUser, inUser);
    addHistory("In Time", formatDate(batch.inTime), formatDate(inTime));
    addHistory("Location", batch.location, location);

    const newBatchEditHistory = batchEditHistory
      ? batchEditHistory + "\n" + changes.join("\n")
      : changes.join("\n");

    const microResultSubmission = {
      BatchId: batch.id,
      Id: batch.id,
      InTime: inTime,
      InUser: inUser,
      BatchEditHistory: newBatchEditHistory + "(At Micro Out) _____",
      Location: location,
    };

    try {
      const response = await UpdateBatchInfo(microResultSubmission, batch.id);
      onSave(response);
      onClose();
      NotificationManager.success("Changes Saved");
    } catch (error) {
      NotificationManager.error("Failed to save the batch:", error.message);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Micro Out Batch</DialogTitle>
      <DialogContent>
        <div className="columns">
          <div className="column">
            <label htmlFor="inUser" className="label">
              {`Previous In User: ${pinUser}`}
            </label>
            <select
              id="inUser"
              className="input"
              value={inUser}
              onChange={(e) => setInUser(e.target.value)}
              fullWidth
              margin="normal"
            >
              {users.map((user) => (
                <option key={user} value={user.trim()}>
                  {user.trim()}
                </option>
              ))}
            </select>
          </div>
        </div>
        <TextField
          label="In Time"
          type="datetime-local"
          value={inTime}
          onChange={(e) => setInTime(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          select
          label="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          fullWidth
          margin="normal"
        >
          {locations.map((loc) => (
            <MenuItem key={loc} value={loc}>
              {loc}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSaveClick} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMicroOutBatchDialog;
